import { gql } from '@apollo/client';

export const QUERY_COMPLETED_TASK = gql`
  query dailyTaskHasBeenCompleted($day: Date!, $type: String!, $relationID: Int!, $userId: ID!) {
    completedTasks(
      filters: {
        day: { eq: $day }
        type: { eq: $type }
        done: { eq: true }
        relationID: { eq: $relationID }
        user: { id: { eq: $userId } }
      }
    ) {
      data {
        attributes {
          metadata
        }
      }
    }
  }
`;

export const QUERY_TRACKING_EMOTION = gql`
  query dailyTrakingEmotion($startDay: Date!, $endDay: Date!) {
    emotionTracker(startDay: $startDay, endDay: $endDay) {
      emotion
      day
      isDisabledTracking
    }
  }
`;

export const QUERY_USER_TRACKING_DATA = gql`
  query getUserTrackingData {
    getUserTrackingData {
      dailyStreak
      streakRecord
      emotionsTracked
    }
  }
`;

export const QUERY_FETCH_USER_STREAK = gql`
  query fetchUserStreak($type: String!) {
    fetchUserStreak(type: $type) {
      total
      streak
    }
  }
`;
